import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWrongWay = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 21V9C6 7.33333 6.58333 5.91667 7.75 4.75C8.91667 3.58333 10.3333 3 12 3C13.6667 3 15.0833 3.58333 16.25 4.75C17.4167 5.91667 18 7.33333 18 9V13.2L19.6 11.6L21 13L17 17L13 13L14.4 11.6L16 13.2V9C16 7.9 15.6083 6.95833 14.825 6.175C14.0417 5.39167 13.1 5 12 5C10.9 5 9.95833 5.39167 9.175 6.175C8.39167 6.95833 8 7.9 8 9V21H6Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgWrongWay);
export default ForwardRef;
